const state = {
  routes: []
};
const mutations = {
  updateRoutes (state, payload) {
    state.routes = payload.routes
  }
}
export default {
  state,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/render.js